import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CartItem } from '../entities/cart-item';
import { B2bCartNotification, CartNotificationAction, CartNotificationType } from '../entities/b2b-cart-notification';
import { B2bCartNotificationService } from '../services/b2b-cart-notification.service';

export interface B2bCartNotificationEvent {
  item: CartItem;
  itemIndex: number;
  userIndex: number;
  action: CartNotificationAction;
  notification: B2bCartNotification;
}

@Component({
  selector: 'app-b2b-cart-notifications',
  templateUrl: './b2b-cart-notifications.component.html',
  styleUrls: ['./b2b-cart-notifications.component.scss'],
  standalone: false
})
export class B2bCartNotificationsComponent implements OnInit {
  @Input() item: CartItem;
  @Input() itemIndex: number;
  @Input() userIndex: number;
  @Input() isDisabled = false;

  @Output() notificationAction = new EventEmitter<B2bCartNotificationEvent>();

  selectedNotification: B2bCartNotification | null = null;
  currentNotification: B2bCartNotification | null = null;

  constructor(private cartNotificationService: B2bCartNotificationService) { }

  ngOnInit(): void {
    this.updateNotification();
  }

  private updateNotification(): void {
    if (this.item?.ModelNumber) {
      this.buildNotification();
    } else {
      this.currentNotification = null;
    }
  }

  private buildNotification(): void {
    const notifications = this.cartNotificationService.buildNotifications([this.item]);
    this.currentNotification = notifications.length > 0 ? notifications[0] : null;
  }

  getNotificationIcon(): string | null {
    if (!this.currentNotification) {
      return null;
    }
    return this.currentNotification.type === CartNotificationType.Error ? 'error' : 'warning';
  }

  showNotification(): void {
    this.selectedNotification = this.currentNotification;
  }

  handleAction(action: CartNotificationAction): void {
    if (!this.selectedNotification || !this.item) {
      return;
    }

    this.notificationAction.emit({
      item: this.item,
      itemIndex: this.itemIndex,
      userIndex: this.userIndex,
      action,
      notification: this.selectedNotification
    });
  }
}
